<script setup lang="ts">
import { supportEmail } from '@/config/support'

const mailto = `mailto:${supportEmail}`
</script>

<template>
  <q-banner
    class="bg-warning text-dark q-ma-md"
    rounded
    role="alert"
    data-testid="account-restricted"
  >
    <template #avatar>
      <q-icon name="mdi-alert-circle-outline" />
    </template>
    <div class="text-subtitle1 text-weight-medium">Your account is restricted</div>
    <div>You can browse but not upload, post bounties or respond.</div>
    <div>
      Think this is a mistake?
      <a
        :href="mailto"
        class="text-dark text-weight-medium"
        data-testid="account-restricted-contact"
        >Contact us</a
      >
    </div>
  </q-banner>
</template>
